import React from "react";
import {
  FilterValues,
  ListFilterProviderProps,
  UseListFilterReturn,
} from "./types";

const ListFilterContext = React.createContext<UseListFilterReturn | null>(null);

export const useListFilterContext = <
  TFilterValues extends FilterValues
>(): UseListFilterReturn<TFilterValues> =>
  React.useContext(ListFilterContext) as UseListFilterReturn<TFilterValues>;

export const ListFilterProvider = <TFilterValues extends FilterValues>(
  props: ListFilterProviderProps<TFilterValues>
) => {
  const { children, ...data } = props;

  return (
    <ListFilterContext.Provider value={data as UseListFilterReturn}>
      {props.children}
    </ListFilterContext.Provider>
  );
};
